import { TAU, glow, paint, type Shape } from '../paint';

export const FINE = 2;
const GOLD = '#ffd27a';
export const NOTE_DRAWN = 28;

export interface LarsenLooks {
  readonly light: Shape;
  readonly calmLight: Shape;
  readonly note: Shape;
}

export function paintLarsenLooks(): LarsenLooks {
  const column = (ctx: CanvasRenderingContext2D, blur: number): void => {
    ctx.scale(FINE, FINE);
    if (blur > 0) {
      glow(ctx, GOLD, blur);
    }
    const light = ctx.createLinearGradient(0, -33, 0, 33);
    light.addColorStop(0, '#fff3c4');
    light.addColorStop(0.5, GOLD);
    light.addColorStop(1, '#d68400');
    ctx.beginPath();
    ctx.ellipse(0, 0, 9, 33, 0, 0, TAU);
    ctx.fillStyle = light;
    ctx.fill();
  };
  return {
    light: paint(60 * FINE, 100 * FINE, 33 * FINE, (ctx) => {
      column(ctx, 22);
    }),
    calmLight: paint(60 * FINE, 100 * FINE, 33 * FINE, (ctx) => {
      column(ctx, 0);
    }),
    note: paint(32 * FINE, 40 * FINE, 14 * FINE, (ctx) => {
      ctx.scale(FINE, FINE);
      glow(ctx, GOLD, 10);
      ctx.fillStyle = GOLD;
      ctx.strokeStyle = GOLD;
      ctx.beginPath();
      ctx.ellipse(-4, 10, 6, 4.2, -0.5, 0, TAU);
      ctx.fill();
      ctx.beginPath();
      ctx.moveTo(1.5, 9);
      ctx.lineTo(1.5, -14);
      ctx.lineWidth = 2.6;
      ctx.lineCap = 'round';
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(1.5, -14);
      ctx.quadraticCurveTo(10, -10, 9, -1);
      ctx.quadraticCurveTo(8, -7, 1.5, -8);
      ctx.closePath();
      ctx.fill();
    }),
  };
}
